import { formatDate } from "@/utils";

export const Date = ({ value }) => {
    return formatDate(value);
}
